import fetchWithFallback from '../CMSFetcher/fetchWithFallback';

export const getSizesCategory = async (language: string) => {
  const path = `get-sizes-by-post_type/${language}/category`;
  return fetchWithFallback(path);
};
